export var KeyCode;

(function (KeyCode) {
  KeyCode[KeyCode["Backspace"] = 8] = "Backspace";
  KeyCode[KeyCode["Tab"] = 9] = "Tab";
  KeyCode[KeyCode["Enter"] = 13] = "Enter";
  KeyCode[KeyCode["Shift"] = 16] = "Shift";
  KeyCode[KeyCode["Ctrl"] = 17] = "Ctrl";
  KeyCode[KeyCode["Alt"] = 18] = "Alt";
  KeyCode[KeyCode["Pause"] = 19] = "Pause";
  KeyCode[KeyCode["CapsLock"] = 20] = "CapsLock";
  KeyCode[KeyCode["Escape"] = 27] = "Escape";
  KeyCode[KeyCode["Space"] = 32] = "Space";
  KeyCode[KeyCode["PageUp"] = 33] = "PageUp";
  KeyCode[KeyCode["PageDown"] = 34] = "PageDown";
  KeyCode[KeyCode["End"] = 35] = "End";
  KeyCode[KeyCode["Home"] = 36] = "Home";
  KeyCode[KeyCode["LeftArrow"] = 37] = "LeftArrow";
  KeyCode[KeyCode["UpArrow"] = 38] = "UpArrow";
  KeyCode[KeyCode["RightArrow"] = 39] = "RightArrow";
  KeyCode[KeyCode["DownArrow"] = 40] = "DownArrow";
  KeyCode[KeyCode["Insert"] = 45] = "Insert";
  KeyCode[KeyCode["Delete"] = 46] = "Delete";
  KeyCode[KeyCode["Zero"] = 48] = "Zero";
  KeyCode[KeyCode["One"] = 49] = "One";
  KeyCode[KeyCode["Two"] = 50] = "Two";
  KeyCode[KeyCode["Three"] = 51] = "Three";
  KeyCode[KeyCode["Four"] = 52] = "Four";
  KeyCode[KeyCode["Five"] = 53] = "Five";
  KeyCode[KeyCode["Six"] = 54] = "Six";
  KeyCode[KeyCode["Seven"] = 55] = "Seven";
  KeyCode[KeyCode["Eight"] = 56] = "Eight";
  KeyCode[KeyCode["Nine"] = 57] = "Nine";
  KeyCode[KeyCode["A"] = 65] = "A";
  KeyCode[KeyCode["B"] = 66] = "B";
  KeyCode[KeyCode["C"] = 67] = "C";
  KeyCode[KeyCode["D"] = 68] = "D";
  KeyCode[KeyCode["E"] = 69] = "E";
  KeyCode[KeyCode["F"] = 70] = "F";
  KeyCode[KeyCode["G"] = 71] = "G";
  KeyCode[KeyCode["H"] = 72] = "H";
  KeyCode[KeyCode["I"] = 73] = "I";
  KeyCode[KeyCode["J"] = 74] = "J";
  KeyCode[KeyCode["K"] = 75] = "K";
  KeyCode[KeyCode["L"] = 76] = "L";
  KeyCode[KeyCode["M"] = 77] = "M";
  KeyCode[KeyCode["N"] = 78] = "N";
  KeyCode[KeyCode["O"] = 79] = "O";
  KeyCode[KeyCode["P"] = 80] = "P";
  KeyCode[KeyCode["Q"] = 81] = "Q";
  KeyCode[KeyCode["R"] = 82] = "R";
  KeyCode[KeyCode["S"] = 83] = "S";
  KeyCode[KeyCode["T"] = 84] = "T";
  KeyCode[KeyCode["U"] = 85] = "U";
  KeyCode[KeyCode["V"] = 86] = "V";
  KeyCode[KeyCode["W"] = 87] = "W";
  KeyCode[KeyCode["X"] = 88] = "X";
  KeyCode[KeyCode["Y"] = 89] = "Y";
  KeyCode[KeyCode["Z"] = 90] = "Z";
  KeyCode[KeyCode["LeftWindowKey"] = 91] = "LeftWindowKey";
  KeyCode[KeyCode["RightWindowKey"] = 92] = "RightWindowKey";
  KeyCode[KeyCode["SelectKey"] = 93] = "SelectKey";
  KeyCode[KeyCode["Numpad0"] = 96] = "Numpad0";
  KeyCode[KeyCode["Numpad1"] = 97] = "Numpad1";
  KeyCode[KeyCode["Numpad2"] = 98] = "Numpad2";
  KeyCode[KeyCode["Numpad3"] = 99] = "Numpad3";
  KeyCode[KeyCode["Numpad4"] = 100] = "Numpad4";
  KeyCode[KeyCode["Numpad5"] = 101] = "Numpad5";
  KeyCode[KeyCode["Numpad6"] = 102] = "Numpad6";
  KeyCode[KeyCode["Numpad7"] = 103] = "Numpad7";
  KeyCode[KeyCode["Numpad8"] = 104] = "Numpad8";
  KeyCode[KeyCode["Numpad9"] = 105] = "Numpad9";
  KeyCode[KeyCode["Multiply"] = 106] = "Multiply";
  KeyCode[KeyCode["Add"] = 107] = "Add";
  KeyCode[KeyCode["Subtract"] = 109] = "Subtract";
  KeyCode[KeyCode["DecimalPoint"] = 110] = "DecimalPoint";
  KeyCode[KeyCode["Divide"] = 111] = "Divide";
  KeyCode[KeyCode["F1"] = 112] = "F1";
  KeyCode[KeyCode["F2"] = 113] = "F2";
  KeyCode[KeyCode["F3"] = 114] = "F3";
  KeyCode[KeyCode["F4"] = 115] = "F4";
  KeyCode[KeyCode["F5"] = 116] = "F5";
  KeyCode[KeyCode["F6"] = 117] = "F6";
  KeyCode[KeyCode["F7"] = 118] = "F7";
  KeyCode[KeyCode["F8"] = 119] = "F8";
  KeyCode[KeyCode["F9"] = 120] = "F9";
  KeyCode[KeyCode["F10"] = 121] = "F10";
  KeyCode[KeyCode["F11"] = 122] = "F11";
  KeyCode[KeyCode["F12"] = 123] = "F12";
  KeyCode[KeyCode["NumLock"] = 144] = "NumLock";
  KeyCode[KeyCode["ScrollLock"] = 145] = "ScrollLock";
  KeyCode[KeyCode["SemiColon"] = 186] = "SemiColon";
  KeyCode[KeyCode["Equals"] = 187] = "Equals";
  KeyCode[KeyCode["Comma"] = 188] = "Comma";
  KeyCode[KeyCode["Dash"] = 189] = "Dash";
  KeyCode[KeyCode["Period"] = 190] = "Period";
  KeyCode[KeyCode["ForwardSlash"] = 191] = "ForwardSlash";
  KeyCode[KeyCode["GraveAccent"] = 192] = "GraveAccent";
  KeyCode[KeyCode["OpenBracket"] = 219] = "OpenBracket";
  KeyCode[KeyCode["BackSlash"] = 220] = "BackSlash";
  KeyCode[KeyCode["CloseBracket"] = 221] = "CloseBracket";
  KeyCode[KeyCode["SingleQuote"] = 222] = "SingleQuote";
})(KeyCode || (KeyCode = {}));

export var EventKey;

(function (EventKey) {
  EventKey["Backspace"] = "Backspace";
  EventKey["Tab"] = "Tab";
  EventKey["Enter"] = "Enter";
  EventKey["Shift"] = "Shift";
  EventKey["Ctrl"] = "Ctrl";
  EventKey["Alt"] = "Alt";
  EventKey["Pause"] = "Pause";
  EventKey["CapsLock"] = "CapsLock";
  EventKey["Escape"] = "Escape";
  EventKey["PageUp"] = "PageUp";
  EventKey["PageDown"] = "PageDown";
  EventKey["End"] = "End";
  EventKey["Home"] = "Home";
  EventKey["LeftArrow"] = "ArrowLeft";
  EventKey["UpArrow"] = "ArrowUp";
  EventKey["RightArrow"] = "ArrowRight";
  EventKey["DownArrow"] = "ArrowDown";
  EventKey["Insert"] = "Insert";
  EventKey["Delete"] = "Delete";
  EventKey["Num1"] = "1";
  EventKey["Num2"] = "2";
  EventKey["Num3"] = "3";
  EventKey["Num4"] = "4";
  EventKey["Num5"] = "5";
  EventKey["Num6"] = "6";
  EventKey["Num7"] = "7";
  EventKey["Num8"] = "8";
  EventKey["Num9"] = "9";
  EventKey["A"] = "A";
  EventKey["B"] = "B";
  EventKey["C"] = "C";
  EventKey["D"] = "D";
  EventKey["E"] = "E";
  EventKey["F"] = "F";
  EventKey["G"] = "G";
  EventKey["H"] = "H";
  EventKey["I"] = "I";
  EventKey["J"] = "J";
  EventKey["K"] = "K";
  EventKey["L"] = "L";
  EventKey["M"] = "M";
  EventKey["N"] = "N";
  EventKey["O"] = "O";
  EventKey["P"] = "P";
  EventKey["Q"] = "Q";
  EventKey["R"] = "R";
  EventKey["S"] = "S";
  EventKey["T"] = "T";
  EventKey["U"] = "U";
  EventKey["V"] = "V";
  EventKey["W"] = "W";
  EventKey["X"] = "X";
  EventKey["Y"] = "Y";
  EventKey["Z"] = "Z";
  EventKey["Start"] = "Meta";
  EventKey["Win"] = "Meta";
  EventKey["LeftCommandOrWindows"] = "Meta";
  EventKey["RightCommandOrWindows"] = "Meta";
  EventKey["ScrollLock"] = "ScrollLock";
  EventKey["SemiColon"] = ";";
  EventKey["Equal"] = "=";
  EventKey["Comma"] = ",";
  EventKey["Dash"] = "-";
  EventKey["Period"] = ".";
  EventKey["ForwardSlash"] = "/";
  EventKey["GraveAccent"] = "`";
  EventKey["OpenBracket"] = "[";
  EventKey["ClosedBracket"] = "]";
  EventKey["SingleQuote"] = "'";
  EventKey["SpaceBar"] = "Space";
})(EventKey || (EventKey = {}));